import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { Table } from '@/js/libs/ui/src/V2';
import { Button } from '../../../../Controls/Button';
import Icons from '../../../../Elements/Icons';
import { Select } from '../../../../Form/Select';
import { PageInfo } from '../PageInfo';
import { paginationPresetDefault, paginationPresetReduced } from './constants';
import { PageInfoWrapper, Wrapper } from './styled';
export const TablePagination = React.memo(function TablePagination({ className, info, pagination, isLoading, dataTestId, }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectedPerPage = React.useMemo(() => ({ label: String(pagination.perPage), value: pagination.perPage }), [pagination.perPage]);
    const isReducedPaginationPreset = React.useMemo(() => !!paginationPresetReduced.find((option) => option.value === pagination.perPage), [pagination.perPage]);
    const handleSetPerPage = useCallbackRef((option) => {
        if (option) {
            pagination.setPerPage(option.value);
            pagination.setPage(0);
        }
    });
    const nextPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev + 1);
    });
    const prevPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev - 1);
    });
    if (!isLoading && info.total <= pagination.perPage) {
        return _jsx(Table.Info, { total: info.total, isLoading: isLoading });
    }
    return (_jsxs(Wrapper, { className: className, "data-testid": dataTestId, children: [!isMobile && (_jsx("div", { "data-testid": 'per-page-dropdown', children: _jsx(Select, { options: isReducedPaginationPreset ? paginationPresetReduced : paginationPresetDefault, value: selectedPerPage, onChange: handleSetPerPage, menuPlacement: 'auto', "data-testid": 'select-op' }) })), _jsx(PageInfoWrapper, { children: _jsx(PageInfo, { dataTestId: 'from-to-total-pagination', ...info, isLoading: isLoading }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: prevPage, disabled: pagination.page === 0, "data-testid": 'backward-button', children: _jsx(Icons.Arrow, { align: 'left' }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: nextPage, disabled: info.total === 0 || pagination.page === Math.ceil(info.total / pagination.perPage) - 1, "data-testid": 'forward-button', children: _jsx(Icons.Arrow, { align: 'right' }) })] }));
});
export { usePageInfo } from './usePageInfo';
export { usePagination } from './usePagination';
